import Router from "vue-router";
import routes from "./routes/index";
import QueryString from "qs";
import startProgressBar from "./routes/middlewares/startProgressBar";
import FetchSettings from "./routes/middlewares/fetchSettings";
import VerifyAppVersion from "./routes/middlewares/verifyAppVersion";
import { isChunkLoadError, reloadOnce } from "src/util/chunkReload";

let router = new Router({
  mode: "history",
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
  parseQuery(query) {
    return QueryString.parse(query);
  },
  stringifyQuery(query) {
    let result = QueryString.stringify(query, { encode: false });

    return result ? "?" + result : "";
  },
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// router.beforeEach(startProgressBar);
router.beforeEach(FetchSettings);
router.beforeEach(VerifyAppVersion);

router.onError(error => {
  if (isChunkLoadError(error)) {
    const pending = router.history.pending;

    reloadOnce(pending ? window.location.origin + router.resolve(pending.fullPath).href : window.location.href);
  }
});

export default router;
